export class SliceSynchronizationModel {
  automaticSliceMatchingOn: boolean;
  panZoomSyncronizationOn: boolean;
}
